export const helpThing=[]
export const helpcont=[]

export const dashboardHelp = {
    screenName:'Basic Setup Guide',
    subTitle : 'Follow the below 4 step process to quickly start creating invoices',
    content:`[{"Q":"Party Master","A":"1. Create your B2B dealers and B2C customers under Party Master."},{"Q":"Item Master","A":"2. Save the items you want to sell in Item Master"},{"Q":"Invoices","A":"3. Now record your sales to the respective dealer for specific items in the Invoices section. For the invoice generated click on Generate IRN to convert it to E-Invoice."},{"Q":"E Invoice","A":"4. To convert an Invoice into E-Invoice, enter the IRN credentials at E-Invoice configuration."}]`
}
